export default "__VITE_ASSET__DAvBwqmJ__"